module.exports = __webpack_public_path__ + "img/printer.b5185d5e.svg";